import React from 'react'
import { useDispatch } from 'react-redux'

// @ts-ignore
import { actions as LKModalActions, LKModalTrigger } from 'shared/LKModal'
// @ts-ignore
import { usePermissions } from 'shared/containers/withConstantPermissions'
// @ts-ignore
import LKButton from 'shared/LKButton'

// TODO: remove after QuickAccessToolbar rework
export const ClientAddNavigationTrigger = ({ name, children }) => {
  const dispatch = useDispatch()

  function handleClick(event) {
    event.preventDefault()
    dispatch(LKModalActions.open({ name }))
  }

  // TODO: permission won't work for this
  return (
    <LKButton alias="client_add" onClick={handleClick} permission="ADD_CLIENT">
      {children}
    </LKButton>
  )
}

export const ClientAddButtonTrigger = ({ className, name, params, disabled, onClose, children }) => {
  const { ADD_CLIENT } = usePermissions()

  if (ADD_CLIENT) {
    return (
      <LKModalTrigger
        alias="client_add"
        className={className}
        params={params}
        name={name}
        disabled={disabled}
        onClose={onClose}
      >
        {children}
      </LKModalTrigger>
    )
  }

  return null
}
